<script>
    import SubPageHeader from '../components/SubPageHeader.svelte'
    import SubNav from '../components/SubNav.svelte'
    import ScheduleTimeline from '../components/ScheduleTimeline.svelte'
    import ScheduleList from '../components/ScheduleList.svelte'
    import ScheduleDaySwitcher from '../components/ScheduleDaySwitcher.svelte'
    import { afterUpdate, onMount } from 'svelte';
    import {replace} from 'svelte-spa-router'

    import { 
        translations, 
        current_lang, 
        festival_days, 
        artists_api_storage, 
        main_venue_ids,
        venues_api_storage,
        x_scroll_pos_history,
        y_scroll_pos_history
    } from '../stores.js';

    export let params = {date, viewmode};

    let all_artists = null
    let main_days = null;
    let selected_day = null;
    let day_artists = [];
    let day_hours = null;
    let readable_main_venues = [];
    let viewmode = "timeline";
    let selected_day_display = null;

    festival_days.subscribe(value => {
		main_days = value.filter(x => x.daytype === "main");
    });

    venues_api_storage.subscribe(value => {
        if(value != null){
            let venuedata;
            if($current_lang == "FI"){
                venuedata = value.fi;
            }
            if($current_lang == "EN"){
                venuedata = value.en;
            }
            let venues_to_add = [];
            for(let i = 0; i < $main_venue_ids.length; i++){
                for(let k = 0; k < venuedata.length; k++){
                    if(venuedata[k].id == $main_venue_ids[i]){
                        let venueinfo = {
                            "id":   venuedata[k].id,
                            "name": venuedata[k].name,
                        }
                        venues_to_add.push(venueinfo);
                    }
                }
            }
            readable_main_venues = venues_to_add;
        }
    });

    function is_concert_in_main_venue(venue_id){
        if($main_venue_ids.includes(parseInt(venue_id))){
            return true;
        }
        return false;
    }

    function set_day_artists(){
        for(let i = 0; i < main_days.length; i++){
            let date = main_days[i].date;
            //init looped days artists
            day_artists[date] = [];

            //find looped days artists
            for(let n = 0; n < all_artists.length; n++){
                let artist = all_artists[n];
                for(let k = 0; k < artist.shows.length; k++){
                    let appearance = all_artists[n].shows[k];

                    if(appearance.dateYmd == date && is_concert_in_main_venue(appearance.place.term_id)){
                        //remove all other shows than today 
                        //(so they are easier to output in schedule and no day checking needed there)
                        artist = clean_artist_shows(artist, date);

                        day_artists[date].push(artist);
                        break;
                    }
                }
            }
        }
    }

    function clean_artist_shows(artist, date){
        let cleaned_shows = artist.shows.filter(x => x.dateYmd == date);
        artist.shows = cleaned_shows;
        return artist;
    }

    artists_api_storage.subscribe(value => {
		all_artists = value;
        if(all_artists != null){
            set_day_artists();
        }
    });

    function convert_date(date){
        let date_parts = date.split("-");
        let display_date = date_parts[2] + "." + date_parts[1] + ".";

        return display_date;
    }

    function get_day_name(date, locale)    {
        var date = new Date(date);
        return date.toLocaleDateString(locale, { weekday: 'short' });        
    }

    function show_day(day, init_scroll_pos = true){
        if(init_scroll_pos){
            $x_scroll_pos_history = null;
            $y_scroll_pos_history = null;
        }
        selected_day = day;
        selected_day_display = get_full_display_date(selected_day);
        replace('/main-concerts/'+selected_day+'/'+viewmode);

        switcher_days = get_day_switcher_days(selected_day);

        refresh_switcher_days();
    }

    function refresh_switcher_days(){
        next_status = true;
        prev_status = true;

        if(switcher_days.next == null){
            next_status = false;
        }
        if(switcher_days.prev == null){
            prev_status = false;
        }
    }

    function get_day_hours(){
        let hours = [];
        let day_start = null;
        let day_end = 0;

        for(let i = 0; i < day_artists[selected_day].length; i++){
            let artist = day_artists[selected_day][i];
            for(let k = 0; k < artist.shows.length; k++){
                let appearance = artist.shows[k];
                if(appearance.dateYmd == selected_day){
                    let start_time = appearance.startTime;
                    let start_hour = start_time.split(":")[0];
                    if(start_hour == "00"){
                        start_hour = 24;
                    }
                    if(!hours.includes(start_hour)){
                        hours.push(parseInt(start_hour));
                    }
                }
            }
        }
        
        hours.sort();
        day_start = hours[0];
        day_end = 24;

        let all_day_hours = [];
        for(let i = day_start; i < day_end; i++){
            all_day_hours.push(i);
        }

        return all_day_hours;
    }

    function get_day_switcher_days(date){
        let switcher_days = {
            prev: null,
            current: date,
            next: null,
        };

        let festival_days_list = main_days;

        for(let i = 0; i < festival_days_list.length; i++){
            if(date == festival_days_list[i].date){
                if (festival_days_list[i - 1] !== undefined) {
                    switcher_days.prev = festival_days_list[i - 1].date;
                }

                if (festival_days_list[i + 1] !== undefined) {
                    switcher_days.next = festival_days_list[i + 1].date;
                }
                return switcher_days;
            }
        }
        return switcher_days;
    }

    function get_full_display_date(date){
        return get_day_name(date, $current_lang) + " " + convert_date(date);
    }
    
    function switch_viewmode(){
        if(viewmode == "timeline"){
            viewmode = "list";
        }else{
            viewmode = "timeline";
        }
        replace('/main-concerts/'+selected_day+'/'+viewmode);
    }

    function prev_day(){
        if(switcher_days.prev != null){
            show_day(switcher_days.prev);
        }
    }

    function next_day(){
        if(switcher_days.next != null){
            show_day(switcher_days.next);
        }
    }

    let switcher_days = null;
    let prev_status = null;
    let next_status = null;

    afterUpdate(() => {
        if(main_days == null){
            return;
        }
        
        // if(selected_day == null){
        //     if(params.date){
        //         selected_day = params.date;
        //     }else{
        //         selected_day = main_days[0].date;
        //     }
        // }
     
        if(day_artists[selected_day] != null){
            day_hours = get_day_hours();
        }
    });

    onMount(() => {
        if(main_days == null){
            return;
        }

        if(params.viewmode != null){
            viewmode = params.viewmode;
        }

        if(selected_day == null){
            if(params.date){
                selected_day = params.date;
            }else{
                selected_day = main_days[0].date;
            }
        }
        
        show_day(selected_day, false);
    });
</script>
{#if selected_day != null}
    <!-- <SubPageHeader page_title={$translations["PROGRAM"][$current_lang] + " - " + get_full_display_date(selected_day) } is_section_main_page={true}/> -->
    <SubPageHeader page_title={$translations["MAIN_CONCERTS"][$current_lang]} is_section_main_page={true}/>
    <SubNav>
        <!-- {#each main_days as day}
            <SubNavButton on:click={() => show_day(day.date)} text={get_full_display_date(day.date)} active={day.date == selected_day} />
        {/each} -->
        {#if next_status != null && prev_status != null}
            <ScheduleDaySwitcher text={selected_day_display} on:prev={prev_day} on:next={next_day} {prev_status} {next_status}/>
        {/if}
    </SubNav>
    {#if viewmode == "timeline"}
        {#if (day_artists[selected_day] != null && day_hours != null) && day_artists[selected_day].length > 0 && readable_main_venues.length > 0}
            <div class="content-container full">
                <ScheduleTimeline venues={readable_main_venues} hours={day_hours} artists={day_artists[selected_day]} />
            </div>
        {:else}
            <div class="content-container">
                {#if $current_lang == "FI"}
                    <p>Sisällön lataaminen ei onnistunut. Ongelma voi johtua siitä, että laitteesi ei saa yhteyttä verkkoon. Jos näet tämän virheilmoituksen vielä yhteyden palauduttua, voit koittaa sulkea sovelluksen ja käynnistää sen uudelleen.</p>
                {:else}
                    <p>Could not load content. Your device may be offline. If your connection has been restored and you still see this error, you can try restarting the app.</p>
                {/if}
            </div>
        {/if}
    {/if}

    {#if viewmode == "list"}
        {#if day_artists[selected_day] != null && day_artists[selected_day].length > 0 && readable_main_venues.length > 0}
            <div class="content-container">
                <ScheduleList display_date={get_full_display_date(selected_day)} venues={readable_main_venues} artists={day_artists[selected_day]} />
            </div>
        {:else}
            <div class="content-container">
                {#if $current_lang == "FI"}
                    <p>Sisällön lataaminen ei onnistunut. Ongelma voi johtua siitä, että laitteesi ei saa yhteyttä verkkoon. Jos näet tämän virheilmoituksen vielä yhteyden palauduttua, voit koittaa sulkea sovelluksen ja käynnistää sen uudelleen.</p>
                {:else}
                    <p>Could not load content. Your device may be offline. If your connection has been restored and you still see this error, you can try restarting the app.</p>
                {/if}
            </div>
        {/if}
    {/if}
{/if}
<div class="floater" class:selected="{viewmode === "list"}">
    <div on:click={switch_viewmode}>
        <img src="img/icons/table-list-solid.svg" class="normal" alt="Change view" />
        <img src="img/icons/table-list-solid-white.svg" class="white" alt="Change view" />
    </div>
</div>



<style>
    .floater{
        position: fixed;
        bottom: 30px;
        right: 15px;
        z-index: 3;
        color: #000;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0;
        
        border-radius: 50%;
        box-sizing: border-box;
        width: 60px;
        height: 60px;
        border: 1px solid var(--darker-medium-color);
        background-color: #fff;
    }
    .floater.selected{
        border: 1px solid var(--darker-medium-color);
        background-color: var(--light-color);
    }
    .floater div{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .floater img{
        width: 20px;
        height: auto;
    }
    .floater img.white{
        display: none;
    }
</style>